export default "__VITE_ASSET__eBdo2LTA__"